<div class="container">
  <div class="row">
    <div class="col-md-4 col-md-offset-4">
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="text-center">
            <h3><img src="../../../assets/img/new_dasboard_imges/loginbluvbay.png" alt="Blubay Logo"/></h3>
            <p *ngIf="hideMobileNumberform">Please enter your registered mobile number</p>
            <p *ngIf="otpFormDisplay">Please enter 6 digits otp</p>
            <div class="panel-body" *ngIf="hideMobileNumberform">
              <form [formGroup]="forgotForm" autocomplete="off" (ngSubmit)="sendOtp()">
                <div class="form-group">
                  <input type="text" name="mobilenumber" [(ngModel)]="userDetails.userName" required
                         formControlName="mobilenumber" placeholder="Mobile number" class="form-control"
                         [ngClass]="{ 'is-invalid': submitted && f.mobilenumber.errors }">
                  <div *ngIf="submitted && f.mobilenumber.errors" class="invalid-feedback">
                    <div *ngIf="f.mobilenumber.errors.required" class="alert-color">Mobile number is required.</div>
                  </div>
                </div>
                <div class="form-group">
                  <button class="send">Send</button>
                </div>
              </form>
            </div>
            <div class="panel-body" *ngIf="otpFormDisplay">
              <form [formGroup]="otpForm" autocomplete="off" (ngSubmit)="verifyOtp()">
                <div class="form-group">
                  <input type="text" name="otpverify" [(ngModel)]="otpVerifyDetails.otp" required
                         formControlName="otp" placeholder="Enter Otp" class="form-control"
                         [ngClass]="{ 'is-invalid': otpSubmitted && f1.otp.errors }">
                  <div *ngIf="otpSubmitted && f1.otp.errors" class="invalid-feedback">
                    <div *ngIf="f1.otp.errors.required" class="alert-color">Otp is required.</div>
                  </div>
                </div>
                <div class="row" style="margin-bottom: 15px">
                  <span (click)="resendOtp()" class="resend" [ngClass]="disabledResendOtp ? 'disbledCls' : ''">Resend OTP </span>
                  &nbsp;<span id="time" *ngIf="hideTimer">{{countDownEle}}</span><span id="timer"
                                                                                       *ngIf="resendhideTimer">{{resendcountDownEle}}</span>
                </div>
                <div class="form-group">
                  <button class="send">Verify</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
